import React from 'react';
import ReactDOM from 'react-dom/client';
import { RouterProvider, createRouter } from '@tanstack/react-router';
import { QueryClient, QueryClientProvider, QueryCache, MutationCache } from '@tanstack/react-query';
import { AuthProvider } from '@/contexts/AuthContext';
import { NotificationProvider } from '@/contexts/NotificationContext';
import { PortalSocketProvider } from '@/contexts/PortalSocketContext';
import { routeTree } from './routeTree.gen';
import { toast } from '@/components/ui/toast';
import '@/i18n'; // must be imported before any component that uses useTranslation
import '@/styles/globals.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: { staleTime: 30_000, retry: 1 },
  },
  queryCache: new QueryCache({
    onError: (error) => toast.networkError(error),
  }),
  mutationCache: new MutationCache({
    onError: (error) => toast.networkError(error),
  }),
});

const router = createRouter({ routeTree });

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <NotificationProvider>
        <AuthProvider>
          <PortalSocketProvider>
            <RouterProvider router={router} />
          </PortalSocketProvider>
        </AuthProvider>
      </NotificationProvider>
    </QueryClientProvider>
  </React.StrictMode>,
);
